import { render, staticRenderFns } from "./importacoes.vue?vue&type=template&id=49aeffb2"
import script from "./importacoes.vue?vue&type=script&lang=js"
export * from "./importacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports